import React from 'react';
import { Redirect, Route, Switch } from "react-router";
import { List } from "./List";
import { Add } from "./Add";

function DescargaSAT({ match }) {
    const { path } = match;
    return (
        <Switch>
            <Route exact path={path} component={List} />
            <Route path={`${path}/add`} component={Add} />     
            <Redirect from="*" to={{
                                pathname: List
                            }}/>
        </Switch>
    ); 
}


export { DescargaSAT };